import React from "react";
import { Row, Col } from "react-flexbox-grid";
import "./contactSocial.scss";


import LinkedinIcon from "../../../assets/contact/linkedin.svg";

import GithubIcon from "../../../assets/contact/github.svg";

const contactSocial = () => (
  <Row>
    <Col xs={12}>
      <Row center="xs">
      
        <Col xs={12} lg={1} className="contact__social">
          <img src={LinkedinIcon} alt="LinkedIn" onClick={()=> window.open("https://www.linkedin.com/in/labib-rahman-146858153/", "_blank")}/>
        </Col>
        <Col xs={12} lg={1} className="contact__social">
          <img src={GithubIcon} alt="LinkedIn" onClick={()=> window.open("https://github.com/labibrah", "_blank")}/>
        </Col>
      </Row>
    </Col>
  </Row>
);

export default contactSocial;
